import config from '../config';

export interface LinkedInDMRequest {
    industry: string;
    target_role: string;
    tone_of_voice: string;
    value_proposition: string;
    additional_context?: string;
}

export interface LinkedInDMResponse {
    research: string;
    sequence: string[];
}

export async function generateLinkedInDMSequence(request: LinkedInDMRequest): Promise<LinkedInDMResponse> {
    try {
        console.log('Generating LinkedIn DM sequence with config:', {
            apiUrl: config.apiUrl,
            request
        });

        const response = await fetch(config.getFullUrl('/generate-linkedin-sequence'), {
            method: 'POST',
            ...config.fetchOptions,
            body: JSON.stringify(request)
        });

        if (!response.ok) {
            console.error('API Error Response:', {
                status: response.status,
                statusText: response.statusText,
                headers: Object.fromEntries(response.headers.entries())
            });
            
            const errorText = await response.text();
            console.error('Error Response Body:', errorText);
            
            throw new Error(`API request failed: ${response.status} ${response.statusText}`);
        }

        const data = await response.json();
        console.log('API Response:', data);
        
        return data;
    } catch (error) {
        console.error('Error generating LinkedIn DM sequence:', error);
        throw error;
    }
} 